import "./About.module.css";
import Header from "@/reusable_sections/Header";
import TheStrategicPhilosophy from "./sections/TheStrategicPhilosophy";
import TheArchitects from "./sections/TheArchitects";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <TheStrategicPhilosophy />
      <TheArchitects />
      <Footer />
    </div>;
}